import { useNavigate } from "react-router-dom"
import logoHeader from "../../assets/logoHeader.png"
import { useAuth } from "../../hooks/useAuth"

interface HeaderProps {
    showLogout?: boolean
}

export const Header = ({ showLogout = true }: HeaderProps) => {
    const navigate = useNavigate()
    const { logout } = useAuth()

    const handleClick = (value: string) => {
        navigate("/" + value)
    }

    return (
        <div className="flex items-center justify-between w-full h-28 px-4">
            <button
                onClick={() => handleClick("home")}
                className="flex items-center justify-center h-24 bg-white rounded-lg w-72"
            >
                <img
                    className="w-[100%] h-[90%]"
                    src={logoHeader}
                    alt="LogPlace Logo"
                />
            </button>

            {showLogout && (
                <button
                    onClick={logout}
                    className="flex items-center space-x-2 px-4 py-2 bg-red-500 hover:bg-red-600 text-white font-medium rounded-lg transition-colors"
                >
                    <svg
                        className="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                        />
                    </svg>
                    <span>Sair</span>
                </button>
            )}
        </div>
    )
}
